"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LlamadaALaAccionFinal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-dark-background text-foreground-dark py-20 px-6">
      <div className={`max-w-3xl mx-auto text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Estás a un paso de dejar de sentirte bloqueado y volver a tener claridad</h2>
        <p className="text-lg md:text-xl text-foreground-dark/80 mb-8">Si algo dentro de ti te dice que necesitas un cambio, no lo ignores.Esa sensación no aparece por casualidad. Y este puede ser el punto de partida.</p>
        <Button asChild size="lg" className="bg-accent text-foreground-accent hover:bg-accent-hover hover:shadow-strong hover:-translate-y-1 active:bg-accent-active active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] text-base md:text-lg px-8 py-4 h-auto">
          <Link to="/ContactReserveSessionPage">Da el primer paso</Link>
        </Button>
      </div>
    </section>;
}